// ThemeTypeService.ts
import { axiosRequest } from "./AxiosService";
import { ThemeTypeListResponse, ThemeTypeResponse } from "../type/response/ThemeTypeResponse";
import { ThemeType } from "../pages/ThemeManagement/data/ThemeType";

/**
 * テーマ一覧を取得
 */
export const getThemes = async (): Promise<ThemeType[]> => {
  try {
    const response = await axiosRequest<ThemeTypeListResponse>(
      "/themes",
      "GET"
    );

    // 取得したデータのフォーマット化
    const formattedThemes: ThemeType[] = response.data.map((item: ThemeTypeResponse) => {
      const formattedTheme: ThemeType = {
        id: item.id,
        themeName: item.themeName,
        iconName: item.iconName,
        iconColor: item.iconColor,
        iconBgColor: item.iconBgColor,
        iconBdColor: item.iconBdColor,
        buttonColor: item.buttonColor,
        fontColor: item.fontColor,
        buttonBdColor: item.buttonBdColor,
        themeDescription: item.themeDescription,
      };
      return formattedTheme;
    });

    return formattedThemes;

  } catch (error) {
    console.error("テーマ一覧の取得に失敗しました:", error);
    return [];
  }
};

/**
 * テーマ新規作成
 * @param themeData テーマデータ
 */
export const createTheme = async (themeData: Omit<ThemeType, "id">): Promise<boolean> => {
  try {
    const response = await axiosRequest<boolean>(
      "/createTheme",
      "POST",
      {
        data: {
          themeName: themeData.themeName,
          iconName: themeData.iconName,
          iconColor: themeData.iconColor,
          iconBgColor: themeData.iconBgColor,
          iconBdColor: themeData.iconBdColor,
          buttonColor: themeData.buttonColor,
          fontColor: themeData.fontColor,
          buttonBdColor: themeData.buttonBdColor,
          themeDescription: themeData.themeDescription,
        },
      }
    );
    return response;
  } catch (error) {
    console.error("テーマの新規作成に失敗しました:", error);
    return false;
  }
};

/**
 * テーマ更新
 * @param id テーマID
 * @param themeData テーマデータ
 */
export const updateTheme = async (id: string, themeData: Omit<ThemeType, "id">): Promise<boolean> => {
  try {
    const response = await axiosRequest<boolean>(
      "/updateTheme",
      "POST",
      {
        data: {
          id: id,
          themeName: themeData.themeName,
          iconName: themeData.iconName,
          iconColor: themeData.iconColor,
          iconBgColor: themeData.iconBgColor,
          iconBdColor: themeData.iconBdColor,
          buttonColor: themeData.buttonColor,
          fontColor: themeData.fontColor,
          buttonBdColor: themeData.buttonBdColor,
          themeDescription: themeData.themeDescription,
        },
      }
    );
    return response;
  } catch (error) {
    console.error("テーマの更新に失敗しました:", error);
    return false;
  }
};

/**
 * テーマ削除
 * @param id テーマID
 */
export const deleteTheme = async (id: string): Promise<boolean> => {
  try {
    const response = await axiosRequest<boolean>(
      "/deleteTheme",
      "DELETE",
      {
        data: {
          id: id,
        },
      }
    );
    return response;
  } catch (error) {
    console.error("テーマの削除に失敗しました:", error);
    return false;
  }
};
